import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { trimCharacterLeft, trimCharacterRight } from '../utilities/trimCharacter'

@Injectable({
    providedIn: 'root',
})
export class BaseHrefService {
    private renderer: Renderer2

    constructor(rendererFactory2: RendererFactory2, @Inject(DOCUMENT) private document) {
        this.renderer = rendererFactory2.createRenderer(null, null)
    }

    private _baseHref: string

    get baseHref() {
        if (!this._baseHref) {
            this._baseHref = this.extractBaseHref()
        }

        return this._baseHref
    }

    private extractBaseHref(): string {
        let href

        const baseHrefElement = this.document.querySelector('base')
        if (baseHrefElement) {
            href = baseHrefElement.href || undefined
        }

        return href
    }

    createUrl(targetPath: string) {
        return `${trimCharacterRight(this.baseHref, '/')}/${trimCharacterLeft(targetPath, '/')}`
    }
}
